export const ROLES = {
  MANAGER: 'gerente',
  EXECUTIVE: 'ejecutivo',
  VENUE: 'centro_de_consumo'
} as const

export type Role = (typeof ROLES)[keyof typeof ROLES]

export const CATEGORIES = {
  PRO: 'PRO',
  MASTER: 'Master',
  ELITE: 'Elite',
  CHAMPION: 'Champion'
} as const

export type Category = (typeof CATEGORIES)[keyof typeof CATEGORIES]

export interface User {
  uid: string
  name: string
  firstName: string
  lastName: string
  email: string
  avatar: string
  authenticated: boolean
  role: Role | null
  category: Category | null
  /** Saldo para redimir premios; en pantalla se muestra como monedas. */
  points: number
  /**
   * Centros de consumo del participante, por su tag («cdc_1»). El gerente tiene
   * uno y el ejecutivo, los que atiende.
   */
  venueTags: string[]
}
